import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';

export default {
  [RINGS_TYPE.Phone_Ring1]: 'Phone Ring 1',
  [RINGS_TYPE.Phone_Ring2]: 'Phone Ring 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Acoustic Dreams',
  [RINGS_TYPE.Air_Raid]: 'Air Raid',
  [RINGS_TYPE.Allusive]: 'Allusive',
  [RINGS_TYPE.Attention]: 'Attention',
  [RINGS_TYPE.Blub_Blub]: 'Blub Blub',
  [RINGS_TYPE.Buzzy]: 'Buzzy',
  [RINGS_TYPE.Channel_Open]: 'Channel Open',
  [RINGS_TYPE.Contemplation]: 'Contemplation',
  [RINGS_TYPE.Crystal_Ball]: 'Crystal Ball',
  [RINGS_TYPE.Disco]: 'Disco',
  [RINGS_TYPE.Door_Bell]: 'Door Bell',
  [RINGS_TYPE.Fairy]: 'Fairy',
  [RINGS_TYPE.Fast_Bells]: 'Fast Bells',
  [RINGS_TYPE.High_Gong]: 'High Gong',
  [RINGS_TYPE.Immersion]: 'Immersion',
  [RINGS_TYPE.Indeed]: 'Indeed',
  [RINGS_TYPE.Lazy_Day]: 'Lazy Day',
  [RINGS_TYPE.Neural_Funk]: 'Neural Funk',
  [RINGS_TYPE.Nice]: 'Nice',
  [RINGS_TYPE.Ring]: 'Ring',
  [RINGS_TYPE.Ringing_Bells]: 'Ringing Bells',
  [RINGS_TYPE.Simple]: 'Simple',
  [RINGS_TYPE.Soothing]: 'Soothing',
  [RINGS_TYPE.Sunshine]: 'Sunshine',
  [RINGS_TYPE.Off]: 'Off',
  add: 'Add',
  delete: 'Delete',
  play: 'Play',
  cancel: 'Cancel',
  confirmToDelete: 'Delete {name}?',
} as const;
